// extracted by mini-css-extract-plugin
export default {"card":"f1-z","carouselContainer":"g1-z","carouselContent":"h1-z"};